import styled from 'styled-components';

interface Props {
  maingtin: boolean;
}

export const GtinProdutoContent = styled.div`
  height: 100%;

  .container-add-gtin {
    display: flex;
    align-items: flex-end;
    width: 100%;
    position: relative;
  }

  .container-add-gtin .input-flex {
    flex: 1 1 auto;
    min-width: 0;
  }

  .container-add-gtin .input-flex > * {
    width: 100%;
  }
`;

export const List = styled.ul<{ isUpdate: boolean }>`
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;
  margin: 0;
  position: relative;
  max-height: 15.9375rem;
  overflow-y: auto;
  padding: 1rem;
  border: 2px solid var(--ds-border-neutral, #dfe1e6);
  border-radius: 3px;
  margin-top: 0.5rem;
  height: ${(props) => (props.isUpdate ? '15.9375rem' : '74%')};
`;

export const ListItem = styled.li<Props>`
  padding: 10px 5px;
  border: 1px solid #bdbdbd;
  border-radius: 8px;
  display: flex;
  align-items: center;
  width: 100%;
  background-color: ${(props) => (props.maingtin ? '#8850BF' : 'none')};
  color: ${(props) => (props.maingtin ? '#fff' : 'none')};
  position: relative;

  .icon {
    margin-right: 5px;
    color: ${(props) => (props.maingtin ? '#fff200' : 'none')};

    &:hover {
      cursor: pointer;
    }
  }

  .options {
    position: absolute;
    right: 0;
    top: 0;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: space-around;
    width: 0;
    background-color: #57069e;
    overflow: hidden;
    border-top-right-radius: 8px;
    border-bottom-right-radius: 8px;
    border-radius: 8px;
    color: white;
    transition: 0.3s;
    font-size: 1.2rem;

    &:hover {
      cursor: pointer;
    }
  }
  &:hover .options {
    width: 30%;
  }
`;
